import React from "react";
import { Collapse } from "../../ui/collapse";
import { TextBox } from "../text-box";
import { useUI } from "../../context";

export const Step1 = () => {
  const {
    page_settings: { step1 },
  } = useUI();

  return (
    <>
      <TextBox title={step1.title} description={step1.description} />

      {step1.terms.map((item, index) => (
        <Collapse key={index} {...item} />
      ))}
    </>
  );
};
